var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"model-box",staticClass:"scheme-box"},[_c('vue-seamless-scroll',{style:({ width: '100%',height: _vm.boxH+'px', overflow: 'hidden' }),attrs:{"data":_vm.situationoptions,"class-option":_vm.defaultOption}},[_c('div',{staticClass:"scheme-box-item"},[_vm._v(" "+_vm._s(_vm.options || '--')+" ")]),_c('div')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }